import { Image, useColorMode } from '@chakra-ui/react';
import pako from "pako";
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { getLocationSelectPagePath } from '../../App';
import Button from '../../components/button';
import Layout from '../../components/layout';
import Text from '../../components/text';
import fetchLocFromIP from '../../helpers/fetchLocFromIP';
import { useSession } from '../../hooks/useSession';
import Logos from '../../images/logos';
import {
    IBookLog,
    IUserLog,
    logClickCreate,
    logClickLink,
    logFetchError,
    logRedirect,
    logUrlError,
} from '../../services/datadog';
import SwalService from '../../services/swal';
import { applyRegionToDeepLink } from '../../utils/deepLink';
import {
    IBettorAccount,
    IUrlData,
    IUserAccount,
    IUserAccountRegion,
    TBookAbbrvs,
} from './../../types';
import UrlFetchErrorPage from './url-fetch-error-page';

/*
|--------------------------------------------------------------------------
| React Page Component
|--------------------------------------------------------------------------
*/

const HeaderText = styled.h1`
    font-weight: 300;
    font-size: 1.1em;
    text-align: center;
    line-height: 1.4em;
`

function generateBranchReferrer(urlDataList: IUrlData[]): string {
    const params: string[] = [];

    console.log(JSON.stringify(urlDataList))

    urlDataList.forEach((data, index) => {
      // Use UrlData.id as the MarketSelection ID
      params.push(`market_selection_id[${index}]=MarketSelection:${data.selectionId}`);

      // Use the oddsNumerator/oddsDenominator or default to 1 if null
      const numerator = data.oddsNumerator ?? 20;
      const denominator = data.oddsDenominator ?? 10;

      console.log("Numerator:", numerator, "Denominator:", denominator);

      params.push(`odds_numerator[${index}]=${numerator}`);
      params.push(`odds_denominator[${index}]=${denominator}`);
    });

    // Referring browser
    params.push(`~referring_browser=Chrome`);

    const deepLink = `https://espnbet.app.link/?${params.join("&")}`;
    //console.log("Deep link before compression:", deepLink);

    // Gzip compress
    const gzipped = pako.gzip(deepLink);
    // Base64 encode
    const base64Encoded = btoa(String.fromCharCode.apply(null, Array.from(gzipped)));
    // URL-encode Base64
    const urlEncoded = encodeURIComponent(base64Encoded);

    return urlEncoded;
  }

export function getBetUrl(region: string, urlDataList: IUrlData[], bookAbbr: string) {

    const isMobileDevice =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        );

    const isAndroid = /Android/i.test(navigator.userAgent);

    var betUrl: string;
    var optionString: string;
    let urlData = urlDataList[0];
    if (bookAbbr === 'mg') {
        if (isMobileDevice && !isAndroid) {
            // iOS and other mobile devices use deep link
            betUrl = 'betmgmsports://';
        } else if (region == 'on') {
            // Android and desktop use HTTPS URL
            betUrl = `https://www.on.betmgm.ca/en/sports`;
        } else {
            betUrl = `https://sports.betmgm.com/en/sports`;
        }

        optionString = `?options=${urlData.eventId}-${urlData.marketId}-${urlData.selectionId}`;
        for (let i = 1; i < urlDataList.length; i++) {
            let urlData = urlDataList[i];
            optionString = optionString.concat(
                `,${urlData.eventId}-${urlData.marketId}-${urlData.selectionId}`
            );
        }

        betUrl = betUrl.concat(optionString);
        if (urlDataList.length === 1) betUrl = betUrl.concat('&type=Single');
        else betUrl = betUrl.concat('&type=Combo');
    } else if (bookAbbr === 'ca') {

        if (isAndroid) {
            // Android-specific deep link format
            if (region == 'on') betUrl = `caesarssportsbook://ca/${region}/bet?dl=betslip`;
            else betUrl = `caesarssportsbook://us/${region}/bet?dl=betslip`;
        } else if (isMobileDevice) {
            // iOS and other mobile devices
            if (region == 'on') betUrl = `caesarssportsbook://ca/${region}/bet/betslip`;
            else betUrl = `caesarssportsbook://us/${region}/bet/betslip`;
        }
        else if (region == 'on') betUrl = `https://sportsbook.caesars.com/on/${region}/bet/betslip`;
        else betUrl = `https://sportsbook.caesars.com/us/${region}/bet/betslip`;

        optionString = isAndroid ? `&selectionIds=${urlData.selectionId}` : `?selectionIds=${urlData.selectionId}`;
        for (let i = 1; i < urlDataList.length; i++) {

            let urlData = urlDataList[i];
            optionString = optionString.concat(`,${urlData.selectionId}`);
        }
        betUrl = betUrl.concat(optionString);
    } else if (bookAbbr === 'fd') {
        if (isMobileDevice)
            betUrl = `fanduelsportsbook://account.sportsbook.fanduel.com/sportsbook/addToBetslip`;
        else betUrl = `https://sportsbook.fanduel.com/addToBetslip`;

        optionString = `?marketId[0]=${urlData.marketId}&selectionId[0]=${urlData.selectionId}`;
        for (let i = 1; i < urlDataList.length; i++) {
            let urlData = urlDataList[i];
            optionString = optionString.concat(
                `&marketId[${i}]=${urlData.marketId}&selectionId[${i}]=${urlData.selectionId}`
            );
        }
        betUrl = betUrl.concat(optionString);

    } else if (bookAbbr === 'dk') {
        if (isMobileDevice) betUrl = `dksb://sb/addbet/${encodeURIComponent(urlData.selectionId!)}`;
        else
            betUrl = `https://sportsbook.draftkings.com/event/${urlData.eventId}?outcomes=${encodeURIComponent(urlData.selectionId!)}`;
        for (let i = 1; i < urlDataList.length; i++) {
            let urlData = urlDataList[i];
            betUrl = betUrl.concat(`+${encodeURIComponent(urlData.selectionId!)}`);
        }
    } else if (bookAbbr === 'bs') {

        if (isMobileDevice) betUrl = 'https://espnbet.app.link/';
        else
            betUrl = 'https://espnbet.com/'

        let oddsDenomString = '?odds_denominator%5B0%5D=1'
        for (let i = 1; i < urlDataList.length; i++) {
            oddsDenomString = oddsDenomString.concat(`&odds_denominator%5B${i}%5D=1`);
        }

        let marketSelectionString = ''
        for (let i = 0; i < urlDataList.length; i++) {
            let urlData = urlDataList[i];
            marketSelectionString = marketSelectionString.concat(`&market_selection_id%5B${i}%5D=MarketSelection%3A${encodeURIComponent(urlData.selectionId!)}`);
        }

        let oddsNumString = ''
        for (let i = 0; i < urlDataList.length; i++) {
            oddsNumString = oddsNumString.concat(`&odds_numerator%5B${i}%5D=2`);
        }

        betUrl = betUrl.concat(oddsDenomString + marketSelectionString + oddsNumString);

        //TEST URL
        //http://localhost:3006/place/parlay/BOOK_c81242f993894e67966b3ccfc4ba3a65?marketSelection=MRKT_039d34ed144d498dba2168de691f6376,MRKT_e0d9b05c8d5e489b9410e8ad8b45a4e2
        //http://localhost:3006/place/MRKT_e5cf77a070bb4e4f86f0ac952465a443/bs

    } else if (bookAbbr === 'br') {
        // iOS uses the rsiri:// deep link; Android and desktop use the region subdomain HTTPS URL
        const isIOS = isMobileDevice && !isAndroid;
        const base = isIOS ? `rsiri://` : `https://${region}.betrivers.com/`;

        // Single ('S') has one selection; parlay ('P') joins all selection ids with commas
        const pickType = urlDataList.length === 1 ? 'S' : 'P';
        let selectionIds = `${urlData.selectionId}`;
        for (let i = 1; i < urlDataList.length; i++) {
            let urlData = urlDataList[i];
            selectionIds = selectionIds.concat(`,${urlData.selectionId}`);
        }

        // %7C is the URL-encoded pipe ('|')
        betUrl = `${base}?page=sportsbook#event/${urlData.eventId}?coupon=${pickType}%7C${selectionIds}%7C0`;

    } else if (bookAbbr === 'pp') {
        if (isMobileDevice) betUrl = 'prizepicks://board';
        betUrl = `https://app.prizepicks.com/board/?projections=${urlData.marketId}`;
        for (let i = 1; i < urlDataList.length; i++) {
            let urlData = urlDataList[i];
            betUrl = betUrl.concat(`,${urlData.marketId}`);
        }
    } else if (bookAbbr === 'ud') {
        if (isMobileDevice) betUrl = 'underdogfantasy://home';
        betUrl = `https://app.underdogfantasy.com/`;
    } else if (bookAbbr === 'kl') {

        // Parlays are not supported for Kalshi - only ever link the first selection.
        // The same https://kalshi.com/markets_by_ticker/... universal link fills out the betslip
        // on desktop, iOS, and Android, so no separate mobile/deep-link handling is needed.
        let urlData = urlDataList[0];
        let eventId = urlData.eventId || '';
        let marketId = urlData.marketId || '';
        let selectionId = urlData.selectionId || '';

        // Kalshi's full market ticker is `{eventTicker}-{selectionSuffix}`:
        //   - selectionSuffix = stored selectionId minus its trailing Y/N side letter
        //   - the trailing Y/N also determines orderSide (Y -> yes, N -> no)
        // Futures store the full event_ticker (which already contains the marketId) in eventId,
        // e.g. eventId "KXMLB-26" with marketId "KXMLB". Game markets store only the event suffix,
        // so their event ticker must be rebuilt as `{marketId}-{eventId}`.
        //   Game market: https://kalshi.com/markets_by_ticker/kxmlbspread-26jul072145torsf-sf4?orderSide=yes
        //   Future:      https://kalshi.com/markets_by_ticker/kxmlb-26-min?orderSide=yes
        const isFuture = eventId.includes(marketId);
        const eventTicker = isFuture ? eventId : `${marketId}-${eventId}`;
        const orderSide = selectionId.endsWith('N') ? 'no' : 'yes';
        const ticker = `${eventTicker}-${selectionId.slice(0, -1)}`.toLowerCase();
        betUrl = `https://kalshi.com/markets_by_ticker/${ticker}?orderSide=${orderSide}`;

    } else if (bookAbbr === 'pm') {
        // Polymarket - parse genericUrlFields to get event_slug
        let urlData = urlDataList[0];
        const genericFields = urlData.genericUrlFields ? JSON.parse(urlData.genericUrlFields) : {};
        const eventSlug = genericFields.event_slug || '';
        betUrl = `https://polymarket.com/event/${eventSlug}`;

    } else if (bookAbbr === 'pn') {
        betUrl = 'https://www.pinnacle.com/en/';

    } else if (bookAbbr === 'hr') {
        if (isMobileDevice) betUrl = `hardrock://betslip/${urlData.selectionId}`;
        else betUrl = `https://app.hardrock.bet/?deeplink=betslip-${urlData.selectionId}`;

        for (let i = 1; i < urlDataList.length; i++) {
            let urlData = urlDataList[i];
            betUrl = betUrl.concat(`,${urlData.selectionId}`);
        }

    } else {
        throw 'Book Type Not Handled'; //shouldn't ever happen
    }

    //Logic to open app store if app isnt present
    return betUrl;
}

export default function BetPlacePage() {
    const session = useSession();
    const { colorMode, toggleColorMode } = useColorMode();
    //set state variables
    const [region, setRegion] = useState('temp');
    const [redirect, setRedirect] = useState(false);
    //const [contextUpdated, setContextUpdated] = useState(false)
    const regionBooks = ['ca', 'br'];

    useEffect(() => {
        if (
            session?.uiMode &&
            session?.uiMode != 'system' &&
            session?.uiMode != colorMode
        )
            toggleColorMode();
    }, []);

    //update selection context with relevant session info
    const updateContext = async (region: string | null) => {
        if (!region) return;

        const timeVisited = new Date().toISOString();
        const url = `${process.env.REACT_APP_API_BASE || ''}/v1/context/?cid=${
            session?.cid
        }`;
        fetch(url, {
            method: 'PUT',
            headers: {
                Authorization: `Token ${process.env.REACT_APP_SUPERUSER_API_KEY}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                region: region,
                timeVisited: timeVisited,
            }),
        })
            .then((response) => {
                if (response.status === 200) {
                    //pass
                } else {
                    console.log(
                        `WARN - update context response: ${response.status}`
                    );
                }
            })
            .catch((err) => {
                console.log(
                    `Unable to update context with location and time - ${err}`
                );
            });
    };

    const validateBookRegion = async (region: string) => {
        let isValid = false;
        session?.userAccounts?.forEach(({ userAccountRegions, book }: any) => {
            userAccountRegions?.forEach(({ bookRegion }: any) => {
                if (
                    bookRegion.abbr === region &&
                    book.name === session?.book?.name
                ) {
                    isValid = true;
                }
            });
        });

        return isValid;
    };

    //fetch loc from current IP
    const fetchLocation = async () => {
        var bookRegion = null;

        //get region from ip, return if valid
        try {
            bookRegion = await fetchLocFromIP();
            let isValid = await validateBookRegion(bookRegion);
            if (bookRegion && isValid) return bookRegion;
        } catch (err) {
            logFetchError('unhandled', null, err);
        }

        //get region from BACT - no need to validate here would be redundant
        //only overwrite bookRegion if the account actually has a region, so a valid
        //IP-derived region isn't discarded when the account's region is empty/unresolved
        if (session?.bettorAccounts) {
            const bettorAccount = session?.bettorAccounts.find(
                (ba: IBettorAccount) => ba?.book?.abbr === session?.book?.abbr
            );
            const bactRegion = bettorAccount?.bookRegion.abbr;
            if (bactRegion) {
                bookRegion = bactRegion;
                return bookRegion;
            }
        }

        //builds dict of valid regions for this book
        //uses to populate swal

        const userAccount = session?.userAccounts
            ? session.userAccounts.find(
                  (ua: IUserAccount) => ua?.book?.abbr === session?.book?.abbr
              )
            : null;
        //this should really never happen
        if (!userAccount) {
            logFetchError('UACT', null, null);
            return bookRegion;
        }
        let validRegions: { [key: string]: string } = {};
        let userAccountRegions = userAccount.userAccountRegions;
        userAccountRegions.sort((a, b) =>
            a.bookRegion.name > b.bookRegion.name
                ? 1
                : b.bookRegion.name > a.bookRegion.name
                ? -1
                : 0
        );

        for (let uar of userAccountRegions) {
            let bookRegion = uar?.bookRegion;
            validRegions[bookRegion.abbr] = bookRegion.name;
        }

        //if bookRegion still null, prompt user to enter region (but only if necessary for the link)
        if (session?.book?.abbr && regionBooks.includes(session?.book?.abbr)) {
            await SwalService.selectRegionSwal(validRegions).then((result: any) => {
                bookRegion = result.value;
            });
        } else {
            return 'None';
        }

        return bookRegion;
    };

    useEffect(() => {
        async function getRegion() {
            await fetchLocation()
                .then((region) => {
                    setRegion(region);
                    updateContext(region);
                })
                .catch((err) => {
                    console.log(`Unable to fetch location - ${err}`);
                });
        }
        getRegion();
    }, []);

    // open tab to make new account on book platform
    const openAffiliateLink = (): void => {
        let bookRegionId: string | null = null;
        session?.userAccounts?.forEach(({ userAccountRegions, book }: any) => {
            userAccountRegions?.forEach(({ bookRegion }: any) => {
                if (
                    bookRegion.abbr === region &&
                    book.name === session?.book?.name
                ) {
                    bookRegionId = bookRegion.id;
                }
            });
        });

        const userAccount = session?.userAccounts
            ? session.userAccounts.find(
                  (ua: IUserAccount) => ua?.book?.abbr === session?.book?.abbr
              )
            : null;

        const userAccountRegion = userAccount?.userAccountRegions.find(
            (uar: IUserAccountRegion) => uar?.bookRegion?.id === bookRegionId
        );

        const userLog: IUserLog | null = !!session?.user
            ? {
                  id: session.user.id,
                  name: session.user.name,
              }
            : null;

        const bookLog: Omit<IBookLog, 'status'> = {
            id: session?.book?.id || '',
            abbr: session?.book?.abbr as TBookAbbrvs,
            name: session?.book?.name || '',
        };

        if (userLog) logClickCreate(session?.cid || '', userLog, bookLog);

        let bookLink =
            userAccountRegion?.affiliateLink ||
            userAccount?.affiliateLink ||
            userAccountRegion?.bookRegion?.url ||
            session?.book?.url;

        if (!bookLink?.match(/^http/)) {
            bookLink = 'https://' + bookLink;
        }

        //log affiliate link click

        //for state specific routing from SS book object url
        bookLink = applyRegionToDeepLink(bookLink, region);

        window.open(bookLink);
    };

    let history = useHistory();
    const onLoginFormClick = () => {
        const userLog: IUserLog | null = !!session?.user
            ? {
                  id: session.user.id,
                  name: session.user.name,
              }
            : null;

        const bookLog: Omit<IBookLog, 'status'> = {
            id: session?.book?.id || '',
            abbr: session?.book?.abbr as TBookAbbrvs,
            name: session?.book?.name || '',
        };

        if (userLog) logClickLink(session?.cid || '', userLog, bookLog);

        //go to the General BookList page
        history.push(getLocationSelectPagePath(session?.cid || ''));
    };

    var betUrl = '';
    var bookName = null;
    var logoUrl = null;
    var userName = null;
    //if (region specific book and not defined) or still temp -> return empty div
    if ((session?.book?.abbr && regionBooks.includes(session?.book?.abbr) && !region)
        || region === 'temp') {
        return <div></div>;
    } else {
        try {
            let localUrls = session?.urlMetadata || [];
            betUrl = getBetUrl(
                region,
                localUrls,
                session?.book?.abbr as TBookAbbrvs
            );
        } catch (err) {
            //log error and send to splash page
            logUrlError(region, session?.urlMetadata, err);
            return <UrlFetchErrorPage />;
        }

        //if existing bettorAccount then route to betUrl
        if (session?.bettorAccount) {
            const userLog: IUserLog | null = !!session?.user
                ? {
                      id: session.user.id,
                      name: session.user.name,
                  }
                : null;

            const bookLog: Omit<IBookLog, 'status'> = {
                id: session?.book?.id || '',
                abbr: session?.book?.abbr as TBookAbbrvs,
                name: session?.book?.name || '',
            };

            if (!redirect) {
                setRedirect(true);
                if (userLog)
                    logRedirect(session?.cid || '', userLog, bookLog, region);
            }

            window.location.href = betUrl;
        } else {
            bookName = session?.book?.name;
            logoUrl = session?.logoUrl;
            userName = session?.user?.name;
        }

        //if we are using the ___ query parameter, we want to skip past the sign in/up prompt
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has('skipLogin')) {
            setRedirect(true);
            //if userLog logRedirect? or is that not relevant here?
            window.location.href = betUrl;
        }
    }

    const onSkipClick = (betUrl: string) => {
        setRedirect(true);
        window.location.href = betUrl;
    };

    if (redirect) {
        return <div></div>;
    }

    const promoText = ((): string | null => {
        const userAccount = session?.userAccounts?.find(
            (ua: IUserAccount) => ua?.book?.abbr === session?.book?.abbr
        );

        const userAccountRegion = userAccount?.userAccountRegions.find(
            (uar: IUserAccountRegion) => uar?.bookRegion?.abbr === region
        );

        return userAccountRegion?.promoText || userAccount?.promoText || null;
    })();

    return (
        <Layout
            colorMode={colorMode}
            alert={session?.user?.isSandbox ? 'SANDBOX MODE' : ''}
        >
            <Image
                style={{ marginBottom: '24px' }}
                w="auto"
                h="45px"
                src={Logos[colorMode]['ss']}
                alt="SharpSports"
            />
            <Text style={{ marginBottom: '24px' }}>
                You don't have a {bookName} account linked with {userName}
            </Text>
            <Button
                onClick={onLoginFormClick}
                w="full"
                style={{ marginBottom: '24px' }}
            >
                Link an existing {bookName} account
            </Button>
            <Button
                onClick={openAffiliateLink}
                w="full"
                variant="secondary"
                style={{ marginBottom: '24px' }}
            >
                Create a new {bookName} account
            </Button>
            {promoText && (
                <Text
                    size="md"
                    lineHeight="18px"
                    mb="16px"
                    mt="-16px"
                    align="center"
                >
                    {promoText}
                </Text>
            )}
            <Button
                onClick={() => onSkipClick(betUrl)}
                w="full"
                variant="tertiary"
                style={{ marginBottom: '12px' }}
                type="submit"
            >
                Skip
            </Button>
        </Layout>
    );
}